module.exports = __webpack_public_path__ + "first-200_hologram.jpg?a195d7321e9399ceae70af4b8ad689fc";


//////////////////
// WEBPACK FOOTER
// ./src/assets/features/first-200_hologram.jpg
// module id = 485
// module chunks = 0